<template>
  <img
    class="transparent-placeholder-image"
    :class="[
      objectFit !== 'contain'
        ? 'transparent-placeholder-image--' + objectFit
        : '',
    ]"
    :src="srcs[ratio] || srcs.square"
    alt="Placeholder"
  />
</template>

<script>
export default {
  name: 'PlaceholderImg',

  props: {
    ratio: { type: String, default: 'square' },
    objectFit: {
      type: String,
      default: 'contain',
      validator(value) {
        return ['contain', 'cover'].includes(value)
      },
    },
  },
  data: () => ({
    srcs: {
      square:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
      '20x7':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAQAAACiwqWzAAAAD0lEQVR42mNkIBIwjkiFAAWbAAglhCTcAAAAAElFTkSuQmC',
      '16x9':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAZCAQAAADz7URgAAAAHUlEQVR42mNkoBJgHDVo1KBRg0YNGjVo1KBhZBAAY84AGtTrOT4AAAAASUVORK5CYII=',
      '5x2':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAACCAQAAAA6Y97WAAAADklEQVR42mNkgANGBBMAADcAA4M6iZcAAAAASUVORK5CYII=',
      '4x3':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAQAAAAe/WZNAAAADklEQVR42mNkgAJGDAYAAFEABCaLYqoAAAAASUVORK5CYII=',
      '3x2':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAADklEQVR42mNkAANGCAUAACMAA2w/AMgAAAAASUVORK5CYII=',
      '2x1':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAAC0lEQVR42mNkAAIAAAoAAv/lxKUAAAAASUVORK5CYII=',
      '5x3':
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAQAAADxPw1zAAAADklEQVR42mNkgANGrEwAAGMABP93vXMAAAAASUVORK5CYII=',
    },
  }),
}
</script>

<style lang="postcss">
.transparent-placeholder-image {
  opacity: 0;
}

.transparent-placeholder-image--cover {
  object-fit: cover;
}
</style>
